import React from "react";
import {
  Row,
  Col,
  Space,
  Tooltip,
  message,
  Button,
  Modal,
  Image,
  Drawer,
} from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import ListTable from "./ListTable";

import withRouter from "../withRouter";

import { CloseOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import CompanyStore from "../store/CompanyStore";
import CompanyAutocomplete from "./CompanyAutocomplete";
import VehicleAuditSore from "../store/VehicleAuditStore";
import VehicleAuditAdd from "./VehicleAuditAdd";
import editIcon from "../assets/images/NewDesign/pencil-square.svg";
import refreshIcon from "../assets/images/NewDesign/refreshicon.svg";
import downloadIcon from "../assets/images/NewDesign/Download.svg";
class VehicleAudit extends React.Component {
  constructor(props, context) {
    super(props);
    this.handleTableChange = this.handleTableChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.onDelete = this.onDelete.bind(this);
    this.companyStore = new CompanyStore(this);
    this.vehicleAuditStore = new VehicleAuditSore(this);
    this.state = {
      loading: false,
      pageSize: 50,
      currentPage: 1,
      loadData: 1,
      companyId: "",
      comp_value: "",
      listDataUpdate: false,
      openVehAuditForm: false,

      openDeleteModal: false,
      deleteData: {},
    };

    this.columns = [
      {
        title: context.translate("_VEHICLE_NO_"),
        dataIndex: "vehicleNo",
        width: 10,

        ellipsis: {
          showTitle: true,
        },
        render: (val, record) => {
          return (
            <Tooltip placement="topLeft" title={val}>
              <Link
                style={{ color: "#2563EB", textDecoration: "none" }}
                onClick={(e) => {
                  e.preventDefault();
                  this.props.canUpdate("vehicleAudit") && this.onEdit(record);
                }}
              >
                {val}
              </Link>
            </Tooltip>
          );
        },
      },
      {
        title: context.translate("_DRIVERID_"),
        dataIndex: "driverName",
        width: 15,
        ellipsis: {
          showTitle: true,
        },
        render: (driverName) => (
          <Tooltip placement="topLeft" title={driverName}>
            {driverName}
          </Tooltip>
        ),
      },
      {
        title: context.translate("_DATE_"),
        dataIndex: "date",
        width: 12,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        title: context.translate("_VEHICLE_AUDIT_SCORE_"),
        dataIndex: "vehicleAuditScore",
        width: 12,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        title: context.translate("_ACCIDENT_REASON_"),
        dataIndex: "comments",
        width: 20,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        title: context.translate("_OUTSIDE_PARTY_"),
        dataIndex: "outsidersn",
        width: 15,
        ellipsis: {
          showTitle: true,
        },
        render: (val) => {
          if (val === 1) {
            return <>Yes</>;
          } else if (val === 0) {
            return <>No</>;
          }
        },
      },
      {
        title: context.translate("_ACCIDENT_TYPE_"),
        dataIndex: "accidentType",
        width: 15,
        ellipsis: {
          showTitle: true,
        },
        render: (val) => {
          if (val === 1) {
            return <>Major</>;
          } else if (val === 2) {
            return <>Minor</>;
          }
        },
      },
      {
        title: context.translate("_ACTION_"),
        dataIndex: "action",
        width: 10,
        ellipsis: {
          showTitle: true,
        },
        align: "center",
        render: (_, record) => {
          return (
            <>
              <Space>
                {this.props.canUpdate("vehicleAudit") && (
                  <Tooltip
                    title={this.context.translate("_EDIT_")}
                    placement="bottom"
                  >
                    <Image
                      style={{
                        height: "19px",
                        width: "15px",
                        borderRadius: "0px",
                        cursor: "pointer",
                      }}
                      src={editIcon}
                      onClick={async (e) => {
                        e.preventDefault();
                        await this.onEdit(record);
                      }}
                    ></Image>
                  </Tooltip>
                )}
                {this.props.canDelete("vehicleAudit") && (
                  <Tooltip
                    title={this.context.translate("_DELETE_")}
                    placement="bottom"
                  >
                    <Image
                      src={require("../assets/images/NewDesign/Delete.png")}
                      style={{ cursor: "pointer", width: "15px" }}
                      onClick={() =>
                        this.setState({
                          openDeleteModal: true,
                          deleteData: record,
                        })
                      }
                    ></Image>
                  </Tooltip>
                )}
              </Space>
            </>
          );
        },
      },
    ];
  }
  async componentDidMount() {
    if (
      Number(this.props.getUserData().isadmin) !== -1 &&
      Number(this.props.getUserData().isadmin) !== 3
    ) {
      await this.setState({
        companyId: this.props.getUserData().userCompanyId,
      });

      await this.handleSearch();
    }
    this.setState({ pageSize: 50 });
  }

  async componentDidUpdate(prevProps, prevState) {
    if (prevState.listDataUpdate !== this.state.listDataUpdate) {
      const setAuditStates = this.context.viewStateStore.vehAuditObject;

      await this.setState({ companyId: setAuditStates.companyId });
      if (setAuditStates !== "") {
        await this.vehicleAuditStore.loadData({
          companyId: this.state.companyId,
          offset: (this.state.currentPage - 1) * this.state.pageSize,
          limit: this.state.pageSize,
          page: this.state.currentPage,
        });
        const singleData = await this.companyStore.getCompanyDataById(
          setAuditStates.companyId
        );

        await this.setState({ loadData: 1 });

        await this.setState({ comp_value: singleData });
      }
      this.setState({ listDataUpdate: false });
    }
  }

  onEdit = async (record) => {
    const Id = record.Id;

    if (Id) {
      this.context.viewStateStore.setVehAuditStates({
        companyId: record.companyId,
      });
      await this.setState({ Id: Id });
      await this.setState({ openVehAuditForm: true });
    }
  };

  async onDelete(record) {
    const response = await this.vehicleAuditStore.deleteRecord({
      Id: record.Id,
    });

    if (response?.data?.success === "S") {
      message.success(response.data.message);
      this.setState({ openDeleteModal: false });
      this.handleSearch();
    } else {
      message.error(response.data.message);
    }
  }

  async handleSearch() {
    this.setState({ loading: true });

    await this.vehicleAuditStore.loadData({
      companyId: this.state.companyId,
      offset: (this.state.currentPage - 1) * this.state.pageSize,
      limit: this.state.pageSize,
      page: this.state.currentPage,
    });
    await this.setState({ loadData: 1, loading: false });
  }

  async handleTableChange(pagination, filters, sorter) {
    await this.setState({
      currentPage: pagination.current,
      pageSize: pagination.pageSize,
    });
    await this.handleSearch();
  }

  closeModal = () => {
    this.setState({ openVehAuditForm: false });
  };

  responseMsg = async (resp) => {
    if (resp.success === "S") {
      message.success(resp.message);
      await this.setState({ listDataUpdate: true });
      await this.setState({ openVehAuditForm: false });
      // await this.handleSearch();
    }
  };

  async handleChange(comp) {
    await this.setState({
      companyId: comp.value,
      currentPage: 1,
      pageSize: 50,
    });
    const singleData = await this.companyStore.getCompanyDataById(comp.value);

    await this.setState({ comp_value: singleData });

    await this.handleSearch();
    await this.setState({ loadList: 1 });
  }

  refreshList = async () => {
    this.setState({ loading: true });
    if (this.state.companyId) {
      await this.vehicleAuditStore.loadData({
        companyId: this.state.companyId,
        offset: 0,
        limit: 50,
      });
    }
    this.setState({ loading: false, currentPage: 1 });
  };

  render() {
    return (
      <>
        <div className="listHeader">
          <Row className="listInputRow">
            <Col span={16}>
              <CompanyAutocomplete
                onChange={(value) => this.handleChange(value)}
                value={this.state.comp_value ? this.state.comp_value : null}
                className="searchInput"
                style={{ width: 200 }}
              />
            </Col>
            <Col
              span={8}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
            >
              <Space>
                <Tooltip
                  title={this.context.translate("_REFRESH_")}
                  placement="bottom"
                >
                  <Image
                    style={{
                      height: 18,
                      alignItems: "center",
                      cursor: "pointer",
                      marginInlineEnd: "20px",
                    }}
                    src={refreshIcon}
                    onClick={() => this.refreshList()}
                  ></Image>
                </Tooltip>

                <Button
                  className="downloadExcelButton"
                  disabled={
                    this.vehicleAuditStore?.auditList?.length > 0 ? false : true
                  }
                  onClick={(val) => {
                    let result = [];
                    if (true) {
                      this.columns.map((obj) => result.push(obj.dataIndex));

                      var getData = {
                        companyId: this.state.companyId,
                        colList: result,
                      };
                      if (val) {
                        this.vehicleAuditStore.exportExcel(getData);
                      }
                    }
                  }}
                >
                  <Tooltip
                    title={this.context.translate("_EXPORT_")}
                    placement="bottom"
                  >
                    <Image
                      style={{
                        height: 18,
                        width: "auto",
                      }}
                      src={downloadIcon}
                    />
                  </Tooltip>
                </Button>

                {this.props.canCreate("vehicleAudit") && (
                  <Button
                    className="addButtonClass"
                    onClick={() =>
                      this.setState({ openVehAuditForm: true, Id: "" })
                    }
                  >
                    <Image
                      style={{ marginInlineEnd: "5px", width: 13 }}
                      src={require("../assets/images/NewDesign/plus (Stroke).png")}
                    ></Image>
                    {this.context.translate("_FLEET_ROLE_ROLELIST_ADDBTN_")}
                  </Button>
                )}
              </Space>
            </Col>
          </Row>
          <ListTable
            currentPage={this.state.currentPage}
            total={this.vehicleAuditStore?.total}
            columns={this.columns}
            pageSize={this.state.pageSize}
            dataSource={this.vehicleAuditStore?.auditList}
            loading={this.vehicleAuditStore?.loading}
            onChange={this.handleTableChange}
          />
        </div>

        {this.state.openVehAuditForm && (
          // <Modal
          //   bodyStyle={{ height: "645px" }}
          //   className="formShowModal"
          //   title={this.context.translate("_ACCIDENT_ANALYSIS_")}
          //   centered
          //   open={this.state.openVehAuditForm}
          //   footer={null}
          //   onCancel={() => {
          //     this.setState({ openVehAuditForm: false, Id: "" });
          //   }}
          //   width={665}
          // >
          <Drawer
            className="uploadExcelDrawer"
            width={716}
            closeIcon={false}
            open={this.state.openVehAuditForm}
            placement={
              this.context.locale.language === "arabic" ? "left" : "right"
            }
            footer={false}
            title={
              <div className="formTitle">
                {this.context.translate("_ACCIDENT_ANALYSIS_")}
                <p className="formDescription">
                  {this.context.translate("_VEHICLE_AUDIT_ADD_DESC_")}
                </p>
              </div>
            }
            maskClosable={false}
            onOk={() => this.setState({ openVehAuditForm: false })}
            onCancel={() =>
              this.setState({
                openVehAuditForm: false,
                Id: "",
              })
            }
          >
            <div style={{ height: "100%" }}>
              <VehicleAuditAdd
                Id={this.state.Id}
                companyId={this.state.companyId}
                response={this.responseMsg}
                closeModal={this.closeModal}
              />
            </div>
          </Drawer>
        )}

        {this.state.openDeleteModal && (
          <Modal
            maskClosable={false}
            title={
              <div className="deleteModalTitle">
                <span>
                  {" "}
                  {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
                </span>
                <CloseOutlined
                  style={{ cursor: "pointer", color: "white" }}
                  onClick={() => this.setState({ openDeleteModal: false })}
                />
              </div>
            }
            className="deleteModal"
            description="Are you sure you want to delete this Item? This action cannot be undone."
            centered
            open={this.state.openDeleteModal}
            footer={null}
            width={400}
            closable={false}
          >
            <div className="deleteModalText">
              <p>{this.context.translate("_DELETE_STATUS_")}</p>
            </div>
            <div className="deleteModalButtons">
              <Button
                className="deleteModalCancelButton"
                onClick={() => this.setState({ openDeleteModal: false })}
              >
                {this.context.translate("_FLEET_DASHBORD_SHOWPOI_CANCELBTN_")}
              </Button>

              <Button
                className="deleteModalOkButton"
                onClick={() => this.onDelete(this.state.deleteData)}
              >
                {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
              </Button>
            </div>
          </Modal>
        )}
      </>
    );
  }
}
VehicleAudit.contextType = StoreContext;
export default observer(withRouter(VehicleAudit));
